// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// https://github.com/gatsbyjs/gatsby/issues/13410#issuecomment-486306784
export const onServiceWorkerUpdateReady = () => window.location.reload(true)
